import React, { useEffect, useState } from 'react';
import { KTIcon } from '../../../_metronic/helpers';
import axios from 'axios';
import Loader from "react-js-loader";
import CurrencyFormat from 'react-currency-format';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DataView } from 'primereact/dataview';
import { Accordion, AccordionTab } from 'primereact/accordion';
import MobileUse from '../../modules/mobileUtilities/MobileUse'
import '../myCommitments/filterbutton.css'
import { Cube } from 'react-ionicons'
import OrderExportButton from '../../components/OrderExportButton';
import OrderInfo from './OrderInfo';

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v';

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  return JSON.parse(data);
}

const MyOrders = () => {

  const [loading, setLoading] = useState(false);
  const [orderData, setOrderData] = useState([]);
  
  const [isOpen, setIsOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [toggleFilter, setToggleFilter] = useState("NONE");
  const [filterOpen, setFilterOpen] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [showOrderInfo, setShowOrderInfo] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const [searchQuery,setSearchQuery] = useState("");

    const [daysFilter, setDaysFilter] = useState('15')

    const isMobileDevice = MobileUse();
      const data = orderData

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if(isOpen){
      setToggleFilter("NONE");
    }
  };

  const handleButtonClick = () => {
    console.log("floating button clicked");
  };

  const openFilterBox = ()=>{
    setFilterOpen(true);
  }

  const closeFilterBox = ()=>{
    setFilterOpen(false);
  }

  const apiToken = getLocalData().api_token;

  const API_URL = process.env.REACT_APP_API_URL;
  const ORDERS = `${API_URL}/user/orders`;

  const getOrderData = async (daysFilterData) => {
    setLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${apiToken}` },
      params: {
          days_filter: daysFilterData,
        },
    };
    await axios.get(ORDERS, config)
      .then((response) => {
        setOrderData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getOrderData(daysFilter);
  }, []);

  const startDateObject = new Date(startDate);
  const endDateObject = new Date(endDate);

  const handleSingleSearch = (value)=>{
    setSearchQuery(value)
  }

  const handleFilter = () => {
    if (startDate !== "" && endDate !== "") {
      const filteredItems = orderData.filter(
        (item) =>
          item.order_no?.toLowerCase().includes(searchQuery.toLowerCase()) &&
          item.tracking_id?.toLowerCase().includes(searchQuery.toLowerCase()) &&
          new Date(item.date) >= startDateObject && new Date(item.date) <= endDateObject
      );
      return filteredItems;
    } else {
      const filteredItems = orderData.filter(
        (item) =>
          item.order_no?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.tracking_id?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      return filteredItems;
    }
  };

  const cancleSearch = () => {
    setStartDate("");
    setEndDate("");
    setSearchQuery("")
  };

  const handleDaysChange = (e) => {
    const selectedDays = e.target.value
    setDaysFilter(selectedDays)
    getOrderData(selectedDays)
  }

  const openOrderInfo = (orderId) => {
    setSelectedOrderId(orderId);
    setShowOrderInfo(true);
  };

  const tableHeader = () =>{
    return(
      <>
      <div className="">
        <div className="row">
            <div className="col-lg-4 col-md-12">
              <h4 style={{marginTop: '10px'}}>My Orders</h4>
            </div>
            <div className="col-lg-8 col-md-12 d-lg-flex align-items-center justify-content-end mb-2">
              <div className='d-flex gap-3 align-items-center my-3'>
                  <select
                    id='daysFilter'
                    className='form-select form-select-sm'
                    value={daysFilter}
                    onChange={handleDaysChange}
                  >
                    <option value='15'>15 Days</option>
                    <option value='30'>30 Days</option>
                    <option value='90'>3 Months</option>
                    <option value='365'>365 Days</option>
                    <option value='All'>All Data</option>
                  </select>
              </div>

              <OrderExportButton/>

               <div className="filters-wrap ms-lg-2">
                  {toggleFilter == 'SEARCH' && (
                  <div class="input-group">
                        <input
                          type='text'
                          className='form-control form-control-sm'
                          style={{width:225,borderTopRightRadius:0,borderBottomRightRadius:0}}
                          placeholder='Search here...'
                          value={searchQuery}
                          onChange={(e) => handleSingleSearch(e.target.value)}
                        />
                      <button
                        onClick={() => cancleSearch()}
                        className='btn btn-sm btn-secondary'
                      >
                        <i className="fa-solid fa-xmark fs-3"></i>
                      </button>
                  </div>
            
                )}
              
              {toggleFilter == 'DATE' && (
                  <div class="input-group">
                      <input
                        type='date'
                        className='form-control form-control-sm'
                          style={{width:100}}
                        placeholder='DD-MM-YYYY'
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    <input
                        type='date'
                        className='form-control form-control-sm'
                          style={{width:100}}
                        placeholder='DD-MM-YYYY'
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                      <button
                        onClick={() => cancleSearch()}
                        className='btn btn-sm btn-secondary'
                        disabled={startDate === "" && endDate === ""}
                      >
                        <i className="fa-solid fa-xmark fs-3"></i>
                      </button>
                  </div>
                )}
               </div>
            </div>
        </div>

        </div>
        
      </>

    )
  }

  const filterButton = ()=>{
    return(
      <div className="floating-button-container">
        {isOpen && (
          <div className={`menu-buttons ${isOpen ? 'show' : ''}`}>
            {/* <button className="sub-button" onClick={()=> setToggleFilter("EXPORT")}><i className="fas fa-download"></i></button> */}
            <button className="sub-button" onClick={()=> setToggleFilter("DATE")}><i className="fas fa-calendar-alt"></i></button>
            <button className="sub-button" onClick={()=> setToggleFilter("SEARCH")}><i className="fas fa-search"></i></button>
          </div>
        )}
        <button
          className="main-button"
          onClick={toggleMenu}
        >
          {isOpen ?
          <i className="fas fa-close"></i>
          :
          <i className="fas fa-sliders-h"></i>
          }
          
          
        </button>
      </div>
    )
  }

  const statusBody = (item)=>{
    return(
      <>
      {item.status == 0 && (
        <span className='badge badge-light-success fs-8 fw-bold success_active'>Received</span>
      )}
      {item.status == 1 && (
        <span className='badge badge-light-warning fs-8 fw-bold warning_active'>Pending</span>
      )}
      {item.status == 2 && (
        <span className='badge badge-light-success fs-8 fw-bold success_active'>Active</span>
      )}
      {item.status == 3 && (
        <span className='badge badge-light-danger fs-8 danger_active'>Expired</span>
      )}
      {item.status == 4 && (
        <span className='badge badge-light-danger fs-8 fw-bold danger_active'>Not Good</span>
      )}
      {item.status == 5 && (
        <span className='badge badge-light-warning fs-8 fw-bold warning_active'>Return Pending</span>
      )}
      {item.status == 6 && (
        <span className='badge badge-info fs-8 p-3 fw-bold'>Return Active</span>
      )}
      {item.status == 7 && (
        <span className='badge badge-light-success fs-8 fw-bold success_active'>Return Completed</span>
      )}
      </>
    )
  }

  const srnoBody = (item) =>{
    return (
      <span>{orderData.indexOf(item) + 1}</span>
    );
  }

  const orderBody = (item) =>{
    return (
      <>
      <span>{item.order_no}</span>
      <a
        className="text-dark"
        onClick={() => openOrderInfo(item.order_code)}
      >
        <i className="fa-solid fa-circle-info fa-2x mb-2"></i>
      </a>
      </>    
    );
  }

  const commissionBody = (item) => {
    return(
      <span className='text-dark text-hover-primary fs-6'>
        <CurrencyFormat
          decimalScale={2}
          value={parseFloat(item.commission).toFixed(2)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
        />
      </span>
    )
  };
  
  const priceBody = (item) => {
    return(
      <span className='text-dark text-hover-primary fs-6'>
        <CurrencyFormat
          decimalScale={2}
          value={parseFloat(item.price).toFixed(2)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
        />
      </span>
    )
  };

  const totalBody = (item) => {
    // const total = item.price * item.qty;
    const total = item.total;
    return(
      <span className='text-dark text-hover-primary fs-6'>
        <CurrencyFormat
          decimalScale={2}
          value={parseFloat(total).toFixed(2)}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
        />
      </span>
    )
  };

  // const paymentStatusBody = (item)=>{
  //   if(item.payment_status == 1){
  //   return(
  //     <span className='badge badge-success'>PAID</span>
  //   )
  // }else{
  //   return(
  //     <span className='badge badge-warning'>PENDING</span>
  //   )
  // }
  // }


  const dataViewList = (items)=>{
    return(
      <div className="data-items">
        <Accordion activeIndex={0}>
        {
          items.map((item, idx) => (
            // <DataViewItem item={item} idx={idx}/>
            <AccordionTab
                header={
                    <span className="d-flex align-items-center justify-content-between ">
                        <div className='d-flex align-items-center'>
                          <div className="card shadow p-1 me-3">
                            <Cube
                              color={'#303337ff'} 
                              title={'order'}
                              height="50px"
                              width="50px"
                            />
                          </div>
                          <div className="d-flex flex-column">
                            <h5 className="font-bold white-space-nowrap">{item.order_no}</h5>
                          <h5 className="font-bold white-space-nowrap">{item.tracking_id}</h5>
                          </div>
                        </div>
                        <h6 className='text-success'>${item.total.toFixed(2)}</h6>
                    </span>
                }
            >
                <div>
                  <span><b>Items</b> : {item.items} | <b>Total Qty</b> : {item.qty}</span><br/>
                  <span><b>Total Price</b> : ${item.price.toFixed(2)} | <b>Total Comm</b> : ${item.commission.toFixed(2)}</span><br/>
                  <span><b>Grand Total</b> : ${item.total.toFixed(2)}</span><br/>
                  <span><b>Created On</b> : {item.date}</span><br/>
                  <span><b>Scanned On</b> : {item.departure_date}</span>
                </div>
            </AccordionTab>
          ))
        }
        </Accordion>
      </div>
    )
  }



  const columnStyle = {
    paddingLeft:10,
    paddingRight:10,
    paddingTop:10,
    paddingBottom:10,
    marginLeft:10,
    marginRight:10,
    width:'200px'
  }

  return (
    <div>
      <div className=''>
      <div className='card shadow top-rounded'>
        <div className='card-body px-3 py-5'>
          {!isMobileDevice ? (
        <div className="orders-table prime-table">
        <DataTable value={handleFilter()} removableSort size="large"
        paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
                tableStyle={{ minWidth: '60rem' ,alignItems:'center',marginLeft:'auto', fontSize:15}}
                scrollable scrollHeight="90vh" style={{ minWidth: '50rem' }}
                header={tableHeader}
                >        
          <Column body={srnoBody} header="#" style={columnStyle}></Column>      
          <Column body={orderBody} header="Order ID" sortable style={columnStyle}></Column>
          <Column field="tracking_id" header="Tracking No." sortable style={columnStyle}></Column> 
          <Column field="qty" header="Total Qty" style={columnStyle}></Column>
          <Column body={priceBody} header="Total Price" style={columnStyle}></Column>
          <Column body={commissionBody} header="Total Comm" style={columnStyle}></Column>
          <Column body={totalBody} header="Grand Total" style={columnStyle}></Column>  
          <Column body={statusBody} header="Status" style={columnStyle}></Column> 
          <Column field="date" header="Created Date" sortable style={columnStyle}></Column> 
          <Column field="departure_date" header="Scanned Date" sortable style={columnStyle}></Column> 

        </DataTable>
        </div>
        ) : (
          <div className="card">
            <div className="card-header">{tableHeader()}</div>
            <div className="card-body px-0 py-1">
              <div className="mobile-card-container">
            {data.length === 0 ? (
              <p className="p-text-center ms-5">No Orders Yet..</p>
            ) : (
              <DataView 
                value={handleFilter()}
                listTemplate={dataViewList}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25, 50]}
                paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
              />
            )}
          </div>
            </div>
          </div>
        )}
        </div>
      </div>
      <div style={{zIndex:999}}>
      {filterButton()}
      </div>
      </div>
      <OrderInfo
        show={showOrderInfo}
        orderId={selectedOrderId}
        onHide={() => setShowOrderInfo(false)}
      />
    </div>
  );
}

export default MyOrders;
